export const baseURL = 'https://api.cloudpayments-staging.com/fundz-ms';
export const oldGloryBaseUrl = 'https://api.cloudpayments-staging.com/oldglory-ms';
export const authURL = 'https://api.cloudpayments-staging.com';
export const apiKey = `613a606b20808900019edcd6e0d540ed0f9243e89a7393fd0b46ae92`;
export const tenantName = `OLDGLORY`;
export const QR_BASE_URL = 'https://qr.cloudpayments.com';
export const APP_PROTOCOL = 'oldglorypay-stage';
export const ecommerceBaseUrl = 'https://api.cloudpayments-staging.com/ecommerce-ms';
